import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

export default function AppendixA({ styles, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix A</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Abbreviations / Acronyms</Text>
        </View>
        <View style={[styles.row, styles.section, styles.border]}>
          <View style={[styles.column, styles.vertical, { flex: 1 }]}>
            <Text style={[styles.headerLabel, styles.borderBottom]}>Code</Text>
            <Text>CWA</Text>
            <Text>ft</Text>
            <Text>gpd</Text>
            <Text>gpm</Text>
            <Text>in.</Text>
            <Text>MG</Text>
            <Text>MGD</Text>
            <Text>MGY</Text>
          </View>
          <View style={[styles.column, styles.vertical, { flex: 2 }]}>
            <Text style={[styles.headerLabel, styles.borderBottom]}>
              Description
            </Text>
            <Text>Coastal Water Authority</Text>
            <Text>Foot, Feet</Text>
            <Text>Gallons per Day</Text>
            <Text>Gallons per Minute</Text>
            <Text>Inch, Inches</Text>
            <Text>Million Gallons</Text>
            <Text>Million Gallons per Day</Text>
            <Text>Million Gallons per Year</Text>
          </View>
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
